import { View, Text } from "react-native";
import { useIntercomClient } from "../../../hooks/useIntercom";
import { Modal } from "../../../components";

export default function EligibilityModal({
  eligibilityModalVisible,
  setEligibilityModalVisible,
  eligibilityErrors = [],
}: {
  eligibilityModalVisible: boolean;
  setEligibilityModalVisible: (visible: boolean) => void;
  eligibilityErrors: string[];
}) {
  const intercom = useIntercomClient();
  const handleContactMembershipServices = () => {
    intercom.presentMessageComposer();
  };

  const isPATSuspended = eligibilityErrors.some((error) =>
    error.toLowerCase().includes("suspended from registering for playing ability test")
  );

  return (
    <Modal
      {...{
        visible: eligibilityModalVisible,
        title: "Eligibility Issues",
        onDismiss: () => setEligibilityModalVisible(false),
      }}
    >
      <View className="m-6" testID="ineligible-modal">
        {eligibilityErrors.map((item, idx) => (
          <Text key={idx} className="bg-sky-white text-regular-normal font-500 pb-2">
            {item}.
          </Text>
        ))}
        {!isPATSuspended && (
          <Text className="text-regular-normal font-500 pb-2">
            If you feel this is an error please{" "}
            <Text className="underline text-primary font-500" onPress={handleContactMembershipServices}>
              contact member services.
            </Text>
          </Text>
        )}
      </View>
    </Modal>
  );
}
